import { render, staticRenderFns } from "./Client_activity.vue?vue&type=template&id=35128074"
import script from "./Client_activity.vue?vue&type=script&lang=js"
export * from "./Client_activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports